import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { dashboardLoginPath, dashboardPathForRole } from '../lib/roleDashboard';

export function SiteLoginRedirect() {
  const location = useLocation();
  return <Navigate to={`/clinic-login${location?.search || ''}`} replace />;
}

/** Legacy /track(/:caseRef) → canonical /case-status(/:caseRef), keeping query (tracking token). */
export function TrackRedirect() {
  const location = useLocation();
  const { caseRef } = useParams();
  const path = caseRef ? `/case-status/${encodeURIComponent(caseRef)}` : '/case-status';
  return <Navigate to={`${path}${location?.search || ''}`} replace />;
}

/**
 * /dashboard sends a signed-in person to their role home.
 * Signed-out visitors go to the login for that role (patient login when no role is known).
 */
const RoleDashboardRedirect = () => {
  const { user, userRole, loading, profileLoading } = useAuth();

  if (loading || (user && profileLoading)) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#0A0A0C' }} role="status">
        <div className="w-10 h-10 border-2 border-violet-500 border-t-transparent rounded-full animate-spin" aria-hidden="true" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={dashboardLoginPath(userRole)} replace />;
  }

  return <Navigate to={dashboardPathForRole(userRole)} replace />;
};

export default RoleDashboardRedirect;
